import { useMutation, useQueryClient } from 'react-query';
import { addRSSFeedAPI } from './api';

const RSS_FEEDS = 'rssFeeds';

export const useAddRSSFeed = ({ onSuccess }) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading, isError, error } = useMutation(
    (url) => addRSSFeedAPI(url),
    {
      onSuccess: () => {
        onSuccess();
        queryClient.invalidateQueries(RSS_FEEDS);
      },
    },
  );

  return {
    addRSSFeed: mutate,
    isLoading,
    isError,
    error,
  };
};
